module.exports = __webpack_public_path__ + "assets/img/rozwiazania-dla-wlascicieli-ziem.1b595608.jpg";